import React, { useContext, useState } from 'react';
import {  useFormik } from 'formik';
import { Button, Card, CardContent, makeStyles, TextField } from '@material-ui/core';
import * as Yup from 'yup';
import AppState from '../../context/AppContext'
import { Navigate, useNavigate, useParams } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
    form: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    input: {
        minWidth: '360px',
        backgroundColor: 'white',
        color: 'black',
        '& .MuiFormHelperText-root': {
            color: 'black',
        },
        '& .Mui-error': {
            color: 'black',
        },
    },
    errorText: {
        color: 'red',
        fontSize: '14px',
        fontWeight: 'bold',
        verticalAlign: "middle",
    },
    card: {
        width: '100%',
        maxWidth: '360px',
        margin: '20px auto',
    },
    cardContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    cardHeader: {
        textAlign: 'center',
        color: 'red',
        fontWeight: 'bold',
        fontFamily: '"Great Vibes", cursive',
    },
    error: {
        verticalAlign: "middle",
    },
    submitButton: {
        margin:"20px",
        backgroundColor: 'green',
        color: 'white',
        float:"left"
    },
    closeButton: {
        margin:"20px",
        float: 'right'
    },
}));

const ResetPassword = () => {
    const params = useParams()
    const classes = useStyles();
    const navigate = useNavigate()
    const context = useContext(AppState)
    const [error, setError] = useState('')
    const [redirect, setRedirect] = useState(false)
    const validationSchema = Yup.object().shape( {
        password: Yup.string().min( 6, 'Password must be at least 6 characters' ).required( 'Password is required' ),
        passwordConfirmation: Yup.string().oneOf( [ Yup.ref( 'password' ), null ], 'Passwords must match' ).required( 'Password confirmation is required' )
    } );
    const onSubmit = ( values ) => {
        const data = {
            password: values.password,
            passwordConfirmation: values.passwordConfirmation,
        };
        context.resetPassword(params.resetToken, data).then((data) => {
            if(data){
                setRedirect(true)
            }
        }).catch((error) => {
            setError(error.response.data.message);
                setRedirect(false)
        })
    };
    const {
        values,
        errors,
        touched,
        isSubmitting,
        handleBlur,
        handleChange,
        handleSubmit,
    } = useFormik( {
        initialValues: {
            password: "",
            passwordConfirmation: "",
        },
        validationSchema: validationSchema,
        onSubmit,
    } );
    if(redirect) return <Navigate to="/login" />
    return (
        <Card className={classes.card}>
            <CardContent>
                <form onSubmit={handleSubmit} autoComplete="off" className={classes.form}>
                    <TextField
                        name="password"
                        label="Password"
                        type="password"
                        variant="outlined"
                        margin="normal"
                        id="password"
                        fullWidth
                        placeholder="Enter your password"
                        value={values.password}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={Boolean( errors.password && touched.password )}
                        helperText={touched.password ? errors.password : ""}
                    />
                    <TextField
                        name="passwordConfirmation"
                        label="Password Confirmation"
                        type="password"
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        id="passwordConfirmation"
                        placeholder="Confirm your password"
                        value={values.passwordConfirmation}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={Boolean( errors.passwordConfirmation && touched.passwordConfirmation )}
                        helperText={touched.passwordConfirmation ? errors.passwordConfirmation : ""}
                    />
                </form>
                <p className={classes.errorText}>{error}</p>
                <Button variant="contained" disabled={isSubmitting} className={classes.submitButton} onClick={handleSubmit}>
                    Submit
                </Button>
                <Button variant="contained" className={classes.closeButton} onClick={()=> navigate("/")}>Cancel</Button><br/>
            </CardContent>
        </Card>
    );

}
export default ResetPassword;
